import React, { useEffect } from 'react'
import { useBreadcrumbsContext } from '@/providers/Global'
import type { IAppBreadcrumbsState } from '@/services/Breadcrumbs'

//	///////////////////////
//	MARK: EXPORTS
const BreadcrumbInternal: React.FC<IAppBreadcrumbsState['values'][number]['value']> = ({
  title,
  span,
  skipLocation,
  location,
}) => {
  const Breadcrumbs = useBreadcrumbsContext()

  useEffect(() => {
    const id = Breadcrumbs.add({
      title,
      span,
      skipLocation,
      location,
    })

    return () => {
      Breadcrumbs.delete(id)
    }
  }, [skipLocation, span, title, location])

  return null
}

export const Breadcrumb = React.memo(BreadcrumbInternal) as typeof BreadcrumbInternal
